import { Navigate, Outlet, useLocation } from "react-router-dom";
import SimpleLoader from "../../Loader/SimpleLoader";

export default function ProtectedRoute({
  isAllowed,
  isLoading,
  redirectPath = "/login",
  children,
}) {
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <SimpleLoader className="h-12" />
      </div>
    );
  }

  if (!isAllowed) {
    // The login page brings the user back to the page they opened (e.g. a folder link).
    return <Navigate to={redirectPath} replace state={redirectPath === "/login" ? { from: location } : undefined} />;
  }

  return children ? children : <Outlet />;
}
